import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['dropdownMenu', 'accordion']

  connect() {
    // Calculate main nav top distance  
    $('.site-nav .accordion .collapse').on('show.bs.collapse', (e)=> {
      if ($(window).width() > 768) {
        let scrollTop = $(window).scrollTop(),
        elementOffset = $('#site-nav-accordion').offset().top,
        distance = (elementOffset - scrollTop);

        distance += 101;

        $(e.target).css('top', distance);
      }
    })
  }

  closeSubmenus() {
    $(this.dropdownMenuTargets).each(function(idx, element){
      $(element).collapse('hide');
    });
  }

  closeSubmenusOnScroll() {
    let scrollTop = $(window).scrollTop();
    let siteNavAccordion = $(this.accordionTarget);

    if(siteNavAccordion.length == 0) { return }

    let elementOffset = siteNavAccordion.offset().top;
    let distance = (elementOffset - scrollTop);

    if(distance > 30) { this.closeSubmenus(); }
  }

  showSubmenu(event) {
    let target = $(event.target).children('h4').data('target')

    $(target).collapse('show');

    if(target == undefined){ this.closeSubmenus(); }
  }
}